





























import store from '@/store'
import ApiClient from '@/js/api.js'
import TextBox from '@/views/atoms/TextBox.vue'

export default
  name: 'Bar'

  components: {
    TextBox
  }
  data: () ->
    scrollY: 0
    isLoginFlg: false

  mounted: () ->
    window.addEventListener('scroll', @scroll)
    api = new ApiClient()
    data = await api.get('/member/cart/count')
    store.dispatch('addCartNum', data.count)

  computed: {
    is_login: () ->
      @isLoginFlg = await store.getters.isLogin
      return @isLoginFlg
    cart_num: () ->
      return store.getters.cartNum
  }

  methods: {
    go_user_append:() ->
      @$cookie.set('user_append_url', location.href, 0)
    scroll:() ->
      @scrollY = window.scrollY
  }
